// Central number → Indian-words helper.
//
// This was previously duplicated inline in several form components and also
// exported from utils/agreementpurchasedeal.js. It now lives here only, so the
// wording can never drift between forms.
//
// Used for the "... in Words" preview fields on the token / deal / purchase-deal
// forms. All PDF generation itself happens in the backend
// (Car-Swipe-Backend/g/invoices).

function convertChunk(num, belowTwenty, tens) {
  if (num === 0) return '';
  if (num < 20) return belowTwenty[num];
  if (num < 100)
    return tens[Math.floor(num / 10)] + (num % 10 !== 0 ? ' ' + belowTwenty[num % 10] : '');
  return (
    belowTwenty[Math.floor(num / 100)] +
    ' Hundred' +
    (num % 100 !== 0 ? ' ' + convertChunk(num % 100, belowTwenty, tens) : '')
  );
}

/**
 * Convert a number (or numeric string) to uppercase Indian-system words.
 *   50000  -> "FIFTY THOUSAND"
 *   499999 -> "FOUR LAKH NINETY NINE THOUSAND NINE HUNDRED NINETY NINE"
 * Empty / invalid input returns "ZERO".
 */
export const numberToWordsIndian = (value) => {
  let num = Number(value);
  if (!Number.isFinite(num)) num = 0;
  num = Math.floor(Math.abs(num));
  if (num === 0) return 'ZERO';

  const belowTwenty = [
    'Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten',
    'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen',
  ];
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  const placeValues = ['', 'Thousand', 'Lakh', 'Crore'];

  const parts = [];
  let place = 0;

  while (num > 0) {
    let chunk;
    if (place === 0) {
      chunk = num % 1000;
      num = Math.floor(num / 1000);
    } else {
      chunk = num % 100;
      num = Math.floor(num / 100);
    }

    if (chunk > 0) {
      const words = convertChunk(chunk, belowTwenty, tens);
      parts.unshift(words + (placeValues[place] ? ' ' + placeValues[place] : ''));
    }
    place++;
  }

  return parts.length > 0 ? parts.join(' ').trim().toUpperCase() : 'ZERO';
};

export default numberToWordsIndian;
